module.exports = new __parcel__URL__("lichess-logo.b7315f1b.svg").toString();